import { request } from './client.js';

export interface CheckoutResultDto {
  readonly paymentId: string;
  readonly bookId: string;
  readonly kind: 'book' | 'image_replacement_pack';
  readonly status: 'pending' | 'succeeded' | 'canceled';
  readonly amountMinorUnits: number;
  readonly listAmountMinorUnits: number;
  readonly discountPercent: number;
  readonly discountAmountMinorUnits: number;
  readonly promoCode: string | null;
  readonly confirmationUrl: string | null;
  readonly appliedAt: string | null;
}

export interface PromotionQuoteDto {
  readonly promoCodeId: string;
  readonly code: string;
  readonly name: string;
  readonly listAmountMinorUnits: number;
  readonly discountPercent: number;
  readonly discountAmountMinorUnits: number;
  readonly amountMinorUnits: number;
}

export const monetizationApi = {
  /**
   * `termsVersion` is the edition of the documents this build shows next to the checkbox,
   * the same value registration sends; `acceptedTerms` is literal because the Pay button
   * cannot be pressed without the tick.
   */
  pay: (bookId: string, termsVersion: string, promoCode?: string) =>
    request<CheckoutResultDto>(`/books/${bookId}/pay`, {
      method: 'POST',
      body: { ...(promoCode ? { promoCode } : {}), acceptedTerms: true, termsVersion },
    }),
  quotePromotion: (bookId: string, code: string) =>
    request<PromotionQuoteDto>(`/books/${bookId}/promotion/quote`, {
      method: 'POST',
      body: { code },
    }),
  /** The same checkbox as `pay`: the pack is bought under the same refund policy. */
  buyImageReplacementPack: (
    bookId: string,
    termsVersion: string,
    returnStep: 'illustrations' | 'cover' | 'video',
  ) =>
    request<CheckoutResultDto>(`/books/${bookId}/image-replacement-pack/pay`, {
      method: 'POST',
      body: { returnStep, acceptedTerms: true, termsVersion },
    }),
  payment: (paymentId: string) => request<CheckoutResultDto>(`/payments/${paymentId}`),
};

export function redirectToCheckout(checkout: CheckoutResultDto): void {
  const target = checkout.confirmationUrl ?? paymentReturnUrl(checkout.paymentId);
  const url = new URL(target);
  if (checkout.confirmationUrl && url.protocol !== 'https:') {
    throw new Error('Некорректная ссылка на оплату');
  }
  globalThis.location.assign(url.toString());
}

function paymentReturnUrl(paymentId: string): string {
  const url = new URL(globalThis.location.href);
  url.searchParams.set('payment', paymentId);
  return url.toString();
}
